/**
 * 🚨 GENERATED FILE - DO NOT EDIT DIRECTLY
 * Source: /project_config.json
 */
export const STRINGS = {
  login_title: 'IRUS Chat',
  login_subtitle: 'Sign in to continue',
  server_url_label: 'Server URL',
  username_label: 'Username',
  password_label: 'Password',
  sign_in_button: 'Sign In',
  login_failed_error: 'Login failed',
  connecting_message: 'Connecting to the heavens...',
  welcome_back: 'Welcome back',
  select_channel: 'Select a channel to start chatting.',
  text_channels_header: 'TEXT CHANNELS',
  voice_channels_header: 'VOICE CHANNELS',
  message_placeholder: 'Message #',
  no_messages: 'No messages yet — say hello!',
  admin_panel: 'Admin Panel',
  log_out: 'Log Out',
  join_voice: 'Join Voice',
  leave_voice: 'Leave Voice',
  participants: 'PARTICIPANTS',
  muted: 'Muted',
  unmute: 'Unmute',
  mute: 'Mute',
};
